import { Component, OnInit } from '@angular/core';
import { Novedad } from '../models/novedad.model';
import { NovedadService } from '../services/novedad.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-new-detail',
  templateUrl: './new-detail.component.html',
  styleUrls: ['./new-detail.component.scss'],
})
export class NewDetailComponent implements OnInit {
  novedad: Novedad;
  id: string;
  novedadRel: Novedad;

  constructor(
    private novedadService: NovedadService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.getNovedad();
    this.getNovedadRel();
  }

  getNovedad() {
    const id = +this.activatedRoute.snapshot.paramMap.get('id');
    this.novedadService.getNovedad(id).subscribe((data) => {
      this.novedad = data.data;
    });
  }

  getNovedadRel() {
    const id = +this.activatedRoute.snapshot.paramMap.get('id');
    this.novedadService.getNovedadRel(id).subscribe((data) => {
      this.novedadRel = data.data;
    });
  }

  goToDetail(id) {
    this.novedadRel.id = id;
    this.router.navigate([`detalle-novedad/${this.novedadRel.id}`]);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

}
